import { cn } from "@/lib/utils";

export function Skeleton({ className }) {
  return <div className={cn("animate-pulse rounded-md bg-slate-200/60", className)} />;
}

export function PageSkeleton() {
  return (
    <div className="p-6 lg:p-8" data-testid="page-skeleton">
      <Skeleton className="h-7 w-48 mb-3" />
      <Skeleton className="h-4 w-96 mb-8" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[1,2,3].map(i => (
          <div key={i} className="border border-slate-200 rounded-md p-5 bg-white">
            <Skeleton className="h-3 w-24 mb-3" />
            <Skeleton className="h-8 w-16 mb-2" />
            <Skeleton className="h-3 w-32" />
          </div>
        ))}
      </div>
      <div className="mt-6 border border-slate-200 rounded-md p-5 bg-white space-y-3">
        {[1,2,3,4].map(i => <Skeleton key={i} className="h-4 w-full" />)}
      </div>
    </div>
  );
}
